import { HttpClient, HttpErrorResponse, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BasketAdd } from '../_models/basketadd';
import { BasketLine } from '../_models/basketline';
import { SendOrderData } from '../_models/sendorderdata';

@Injectable({
  providedIn: 'root'
})
export class BasketService {
  baseUrl = environment.apiUrl;
  basketlines: BasketLine[] = [];
  test!: BasketLine;
  test2!: BasketAdd;
  errorMessage!: string;

  constructor(private http: HttpClient) { }

  getAll(): Observable<BasketLine[]> {
/*     return this.http.get<BasketLine[]>(this.baseUrl + 'basket').pipe(
      map(basketlines => {
        return basketlines;
      })
    ); */

    return this.http.get<BasketLine[]>(this.baseUrl + 'basket')
    .pipe(
      tap(data => console.log('order opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleError)
    );
  }

  Add(basket: BasketAdd){
    return this.http.post<BasketLine>(this.baseUrl + 'basket', basket).subscribe(data => { this.test = data; })

  }

  Update(basket: BasketAdd){
    return this.http.put<BasketLine>(this.baseUrl + 'basket', basket).pipe(
      map(() => {
        this.test2 = basket;
      })
    );

  }

  SendOrder(opmerking: string, yourref: string): Subscription{
    let sendorderdata : SendOrderData = {
      message : opmerking,
      yourreference : yourref
    }
    return this.http.post<BasketLine>(this.baseUrl + 'basket/sendorder', sendorderdata).subscribe({
      next: data => { this.test = data; },
      error: err => {
        this.errorMessage = "";
        if (err?.status == 400)
        {
          this.errorMessage = err.Error;
        }
        else{
          this.errorMessage = err;
        }
      }
    })

  }

  UploadExcelfile(formData: FormData, merk: string){
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    headers.delete('Content-Type'); 
    return this.http.post<any>(this.baseUrl + 'basket/' + merk + '/uploadexcel', formData, {reportProgress: true, observe: 'events'});

  }

  UploadExcelfileAllBrands(formData: FormData){
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    headers.delete('Content-Type'); 
    return this.http.post<any>(this.baseUrl + 'basket/uploadexcel', formData, {reportProgress: true, observe: 'events'});

  }

  getUploadHeaders() {
    let headers = new Headers({'Accept': 'application/json'});
    headers.delete('Content-Type');
    return headers;
  } 

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError(
      'Something bad happened; please try again later.');
  }


}
